import moment from 'moment';

export const formatDateShort = (date: unknown): string => moment(date).format('MMM DD');

export const dateToString = (date: Date): string | null => (date ? moment(date).format() : null);

export const stringToDate = (str: string): Date | null => (str ? moment(str).toDate() : null);

export const formatDateTimeWithTimeZone = (date: string): string => moment.utc(date).format('YYYY-MM-DD HH:mm:ss (z)');
